import styled, { DefaultTheme } from 'styled-components';
import NiceInputPassword from 'react-nice-input-password';

const mapColors = ({ theme }: { theme: DefaultTheme }) =>
  theme.type === 'light'
    ? { $color: theme.colors.black[900] }
    : { $color: theme.colors.white[900] };

export const StyledNiceInputPassword = styled(NiceInputPassword).attrs(
  mapColors
)`
  flex: 1;
  .input-password__description {
    margin: 5px auto;
    padding: 0;
    padding-left: 25px;
    li p.MuiTypography-root {
      font-size: 16px;
    }
    li {
      margin: 5px 0;
      color: ${(p) => p.$color};
      &.success {
        color: ${(props) => props.theme.sellerTheme.primary.value};
      }
      &.danger {
        color: ${(props) => props.theme.colors.red[500]};
      }
    }
    li::marker {
      font-size: 20px;
    }
  }
`;
